module.exports = __webpack_public_path__ + "static/media/vf_mknit_core.9ad9e1e1.svg";